module.exports = __webpack_public_path__ + "img/picture_viptc02.7a612d12.png";